// extracted by mini-css-extract-plugin
export default {"page":"mapE7","header":"y7gGu","title":"HiVum","links":"hM7IE","container":"CHsgE","inner":"i3q8u"};